var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('sarala-table',{ref:"table",attrs:{"model":_vm.model,"createRoute":{
                name: 'rule.create',
                params: {
                    category_id: _vm.categoryId,
                },
                query: { cycle_rule: '1' },
            },"resourceName":_vm.$tc('resources.cycle_rule.name', 1),"query":_vm.categoryFilter},scopedSlots:_vm._u([{key:"max_value",fn:function(ref){
            var item = ref.item;
return [_vm._v("\n                "+_vm._s(item.max_value ? item.max_value : '∞')+"\n            ")]}},{key:"percentage",fn:function(ref){
            var item = ref.item;
return [_vm._v("\n                "+_vm._s(_vm.$n(item.percentage / 100, 'percent'))+"\n            ")]}},{key:"action",fn:function(ref){
            var item = ref.item;
return [_c('edit-btn',{attrs:{"to":{
                        name: 'rule.edit',
                        params: { id: item.id, category_id: _vm.categoryId },
                        query: { cycle_rule: '1' },
                    }}}),_c('delete-btn',{on:{"click":function($event){return _vm.deleteItem(item)}}})]}}])})],1),_c('confirm-delete',{ref:"confirmDelete"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }